<template>
  <div
    id="fieldsLibrary"
    class="fields-library fields-library-hide"
  >
    <div class="title-component">{{ isComponent ? 'COMPONENT' : 'TOOLBOX' }}</div>

    <!-- Input Search -->
    <div class="input-search">
      <i class="fa fa-search" />
      <input
        v-model="searchField"
        type="text"
        placeholder="Search"
        autocomplete="off"
      >
    </div>

    <!-- Field List -->
    <div
      v-if="isLoading"
      class="content-component"
    >
      <!-- Skeleton Fields -->
      <j-skeleton-field-library />
    </div>

    <div
      v-else
      class="content-component"
    >
      <div
        v-for="(fields, index) in fieldsLibrary"
        :key="fields.section"
        class="field-section"
      >
        <p
          v-if="fields.section"
          class="title-section"
        >
          {{ fields.section }}
        </p>

        <!-- Field List -->
        <draggable
          :list="fields.fields"
          :group="{ name: 'fieldsLibrary', pull: 'clone', put: false }"
          :options="{ disabled: propertiesOpened || showModalFieldLibrary }"
          class="field-list"
          @start="dragStart($event, index)"
          @end="reset($event, index)"
        >
          <div
            v-for="field in fields.fields"
            v-show="hideFieldByConfig(field.type)"
            :key="field.type"
            :id="field.type"
            class="list"
          >
            <img
              :src="require(`@/assets/new-form-ui/field-icon-active/${field.type}.svg`)"
              class="field-icon field-icon-active"
            >
            <img
              :src="require(`@/assets/new-form-ui/field-icon/${field.type}.svg`)"
              class="field-icon field-icon-default"
            >
            <span>{{ field.name }}</span>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-param-reassign */
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import jSkeletonFieldLibrary from '@/views/experience-manager-v2/loading/jSkeletonFieldLibrary';

export default {
  components: {
    draggable,
    jSkeletonFieldLibrary,
  },

  props: {
    menuActive: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: true,
      searchField: '',
      fieldLists: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'descriptive', name: 'Text Area' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'currency', name: 'Currency' },
            { type: 'currency_selection', name: 'Currency Selection' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
            { type: 'user_single_selection', name: 'User Selection' },
            { type: 'password', name: 'Password' },
            { type: 'toggle', name: 'Toggle' },
            { type: 'checkbox', name: 'Checkbox' },
            { type: 'radio', name: 'Radio' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
            { type: 'time', name: 'Time' },
            { type: 'date_time', name: 'Date Time' },
            { type: 'timer', name: 'Timer' },
          ],
        },
        {
          section: 'Attachment',
          fields: [
            { type: 'single_attachment', name: 'Single Attachment' },
            { type: 'attachment', name: 'Multiple Attachment' },
            { type: 'multiple_attachment_dynamic', name: 'Dynamic Attachment' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'separator', name: 'Separator' },
            { type: 'custom_html', name: 'HTML' },
            { type: 'digital_signature', name: 'Digital Signature' },
            { type: 'code_editor', name: 'Code Editor' },
            { type: 'text_editor', name: 'Text Editor' },
            { type: 'table_group', name: 'Table Group' },
            { type: 'group', name: 'Field Group' },
            { type: 'dynamic_field', name: 'Dynamic Field' },
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
            { type: 'location', name: 'Maps' },
            { type: 'color', name: 'Color' },
            { type: 'slider', name: 'Slider' },
            { type: 'text_label', name: 'Text Label' },
            { type: 'progress_bar', name: 'Progress Bar' },
          ],
        },
      ],
      fieldListsBulk: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'descriptive', name: 'Text Area' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'multiple_selection', name: 'Multiple Selection' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'multiple_relation_record', name: 'Multiple Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
            { type: 'multiple_relation_record_external_api', name: 'Multiple Relation Record Ext API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
          ],
        },
      ],
      fieldListsSearch: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'number', name: 'Number' },
            { type: 'single_selection', name: 'Single Selection' },
            { type: 'user_single_selection', name: 'User Selection' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
          ],
        },
        {
          section: 'Data Connection',
          fields: [
            { type: 'relation_record', name: 'Relation Record' },
            { type: 'relation_record_external_api', name: 'Relation Record External API' },
          ],
        },
        {
          section: 'Others',
          fields: [
            { type: 'single_tags_selection', name: 'Single Tag' },
            { type: 'multiple_tags_selection', name: 'Multiple Tag' },
          ],
        },
      ],
      fieldListsDataset: [
        {
          section: 'Basic',
          fields: [
            { type: 'text', name: 'Text' },
            { type: 'descriptive', name: 'Text Area' },
            { type: 'number', name: 'Number' },
            { type: 'number_decimal', name: 'Number (Decimal)' },
            { type: 'currency', name: 'Currency' },
            { type: 'toggle', name: 'Toggle' },
          ],
        },
        {
          section: 'Date Time',
          fields: [
            { type: 'date', name: 'Date' },
            { type: 'time', name: 'Time' },
            { type: 'date_time', name: 'Date Time' },
          ],
        },
      ],
      fieldListsComponent: [
        {
          section: '',
          fields: [
            { type: 'single_experience_manager', name: 'Single UI' },
            { type: 'multiple_experience_manager', name: 'Multiple UI' },
          ],
        },
      ],
      fieldsLibrary: [],
      fieldSelected: null,
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', ['propertiesOpened', 'showModalFieldLibrary', 'isBulk', 'isSearch', 'isDataset', 'isComponent']),

    fields() {
      let field = null;

      if (this.isBulk) {
        field = this.fieldListsBulk;
      } else if (this.isSearch) {
        field = this.fieldListsSearch;
      } else if (this.isDataset) {
        field = this.fieldListsDataset;
      } else if (this.isComponent) {
        field = this.fieldListsComponent;
      } else {
        field = this.fieldLists;
      }

      return field;
    },
  },

  watch: {
    searchField(val) {
      if (val.length > 0) {
        const dataFields = JSON.parse(JSON.stringify(this.fields));

        dataFields.filter(fields => fields.fields.some(field => field.name.toLowerCase().includes(val.toLowerCase())));
        dataFields.forEach((fields) => {
          fields.fields = fields.fields.filter(field => field.name.toLowerCase().includes(val.toLowerCase()));
        });

        this.fieldsLibrary = dataFields;
      } else {
        this.refreshDataField();
      }
    },

    menuActive() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 400);
    },

    isComponent() {
      this.refreshDataField();
    },

    isDataset() {
      this.refreshDataField();
    },
  },

  created() {
    setTimeout(() => {
      this.insertDataFields();
    }, 200);
    setTimeout(() => {
      this.isLoading = false;
    }, 400);
  },

  methods: {
    insertDataFields() {
      if (this.isBulk) {
        this.fieldsLibrary = this.fieldListsBulk;
      } else if (this.isSearch) {
        this.fieldsLibrary = this.fieldListsSearch;
      } else if (this.isDataset) {
        this.fieldsLibrary = this.fieldListsDataset;
      } else if (this.isComponent) {
        this.fieldsLibrary = this.fieldListsComponent;
      } else {
        this.fieldsLibrary = this.fieldLists;
      }
    },

    refreshDataField() {
      this.isLoading = true;
      this.insertDataFields();
      setTimeout(() => {
        this.isLoading = false;
      }, 400);
    },

    dragStart(event, index) {
      const data = this.fieldsLibrary[index].fields[event.oldIndex];
      this.fieldSelected = data.type;
    },

    reset(data, index) {
      const oldIndex = data.oldIndex;
      const newIndex = this.fieldsLibrary[index].fields.findIndex(field => field.type === this.fieldSelected);
      const element = this.fieldsLibrary[index].fields[newIndex];

      this.fieldsLibrary[index].fields.splice(newIndex, 1);
      this.fieldsLibrary[index].fields.splice(oldIndex, 0, element);
      this.fieldSelected = null;
    },

    hideFieldByConfig(type) {
      if (process.env.DISABLE_CURRENCY_SELECTION === 'true') return type !== 'currency_selection';
      return true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/FieldLibrary.vue